var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 0,
    viewBox: "0 0 512 512",
    height: 18,
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M185.6 29.02c-17.8.64-35.3 16.49-42.9 38.77-9.4 27.43-.7 55.21 19.4 62.11 20.1 6.8 44-9.9 53.3-37.3 9.4-27.42.7-55.21-19.4-62.08-3.3-1.12-6.8-1.63-10.4-1.5zm156 19.6c-10.3.1-22 .98-35.2 2.86 36.5 8.49 67.8 21.18 92.8 39.24L298.6 207.1c7.9 5.8 9.1 7.7 16.8 13.8l101.3-115.7c22.4 21.4 37.7 48.7 44.2 82.9 3.8-35.9-2.7-76-27.4-102.08 7.4-7.89 15.4-15.69 5.6-24.17-12.9-7.89-14.9-.32-23.1 9.25-17-12.63-37.4-22.75-74.4-22.48zM115.1 145.5C69.21 171.2 19.21 253.6 84.86 381c11.29 22-34.56 65.6-60.28 90.3l43.95 6.2c29.82-31.7 52.97-60.7 63.17-98.1 1.6-5.6-16.8-34.7-27.8-62.1 27.9 14.1 73.1 58.4 70.5 76.6-5.1 35.3-15.5 53.2-30.7 84.9l46.7 4.2c11.2-24.1 18.9-52.5 25.6-97.3 2-13.8-23.8-47-61.8-85.1-13.7-13.8-27.1-56.4 10.7-107.9 47.7 18.3 78.8 43.9 118.4 67.6l18.4-21.7c-38.5-30-79.5-65-129.8-88-17.9-8.2-39.9-14.6-56.8-5.1zm345.8 42.6c-16.6 2.1-92 37.8-125.1 56.3l69.3-6.1-86.7 100.2L421 264.2l-14.7 127.2 47.2-131.7 33.9 80.9c-7.2-84.5-11.2-109.1-26.5-152.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinerIcon);
export default __webpack_public_path__ + "static/media/miner-icon.ac3a3f8f5f71efb494f71136c1d2abbe.svg";
export { ForwardRef as ReactComponent };